import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectBankFolderContents } from 'scenes/ProjectBank/services/getProjectBankFolderContents.service';
import { loadUsersAndPersonalResourcesByUserIds } from 'store/projectUsers/thunks/loadUsersAndPersonalResourcesByUserIds';
import { uniq } from 'lodash';

export const loadProjectBankFolderContents = createAsyncThunk(
  'projectBank/loadProjectBankFolderContents',
  async (folderId, { dispatch }) => {
    if (folderId.includes('tilaajavastuu')) {
      return [];
    }
    let nextToken = null;
    const all = [];

    do {
      const page = await getProjectBankFolderContents(folderId, { nextToken });
      const items = page?.items || [];
      all.push(...items);
      nextToken = page?.nextToken || null;
    } while (nextToken);

    if (all.length > 0) {
      const uniqueUserIds = uniq(all.map((fp) => fp.user));
      dispatch(loadUsersAndPersonalResourcesByUserIds(uniqueUserIds));
    }

    return all;
  }
);
